import { useState, useCallback } from 'react';
import { Chatbot } from '../types/chatbot';
import { API_URL } from '../config';

interface UseInstallationReturn {
  openInstallDialog: boolean;
  selectedChatbotForInstall: Chatbot | null;
  copySuccess: boolean;
  handleOpenInstallDialog: (chatbot: Chatbot) => void;
  handleCloseInstallDialog: () => void;
  handleCopyCode: () => Promise<void>;
  getInstallationCode: (chatbotId: string) => string;
}

export const useInstallation = (): UseInstallationReturn => {
  const [openInstallDialog, setOpenInstallDialog] = useState(false);
  const [selectedChatbotForInstall, setSelectedChatbotForInstall] = useState<Chatbot | null>(null);
  const [copySuccess, setCopySuccess] = useState(false);

  const handleOpenInstallDialog = useCallback((chatbot: Chatbot) => {
    setSelectedChatbotForInstall(chatbot);
    setOpenInstallDialog(true);
  }, []);

  const handleCloseInstallDialog = useCallback(() => {
    setSelectedChatbotForInstall(null);
    setOpenInstallDialog(false);
    setCopySuccess(false);
  }, []);

  const getInstallationCode = useCallback((chatbotId: string) => {
    return `<script>
  (function() {
      const config = {
          chatbotId: '${chatbotId}',  // Your chatbot's unique ID
          serverUrl: '${API_URL}' 
      };
  
      const script = document.createElement('script');
      script.src = \`\${config.serverUrl}/widget.js\`;
      script.async = true;
      script.onload = function() {
          if (window.Glowspirit) {
              window.Glowspirit.init(config);
          } else {
              console.error('Glowspirit script failed to load.');
          }
      };
      
      document.body.appendChild(script);
  })();
</script>`;
  }, []);

  const handleCopyCode = useCallback(async () => {
    if (selectedChatbotForInstall) {
      try {
        await navigator.clipboard.writeText(getInstallationCode(selectedChatbotForInstall._id));
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
      } catch (err) {
        console.error('Failed to copy code:', err);
      }
    }
  }, [selectedChatbotForInstall, getInstallationCode]);

  return {
    openInstallDialog,
    selectedChatbotForInstall,
    copySuccess,
    handleOpenInstallDialog,
    handleCloseInstallDialog,
    handleCopyCode,
    getInstallationCode
  };
}; 